import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { fetchPostedProducts } from "../../services/Vegetable";
import { getAllProductsByCategory } from "../../services/productServices";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Spinner from "../shared/Spinner";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function PostByProduct() {
  const [offerData, setOfferData] = useState(null);

  useEffect(() => {
    async function getData() {
      try {
        const categoryName = "Vegetables  / አትክልቶች";
        const categoryProducts = await getAllProductsByCategory(categoryName);
        const productNames = (categoryProducts || []).map((p) => p.name);
        const data = await fetchPostedProducts();

        const offerCounts = productNames.reduce((acc, name) => {
          acc[name] = 0;
          return acc;
        }, {});

        Object.values(data).forEach((category) => {
          category.total.forEach((offer) => {
            const productName = offer.product_name;
            if (productName && offerCounts[productName] !== undefined) {
              offerCounts[productName] += 1;
            }
          });
        });

        const sortedData = productNames
          .map((name, index) => ({
            productName: name,
            index,
            count: offerCounts[name] || 0,
          }))
          .sort((a, b) =>
            b.count === a.count ? a.index - b.index : b.count - a.count
          );

        const processedData = {
          labels: sortedData.map((item) => item.productName),
          datasets: [
            {
              label: "Total Offers",
              data: sortedData.map((item) => item.count),
              backgroundColor: [
                "rgba(255, 99, 132, 0.8)",
                "rgba(54, 162, 235, 0.8)",
                "rgba(255, 206, 86, 0.8)",
                "rgba(75, 192, 192, 0.8)",
                "rgba(153, 102, 255, 0.8)",
                "rgba(255, 159, 64, 0.8)",
                "rgba(99, 255, 132, 0.8)",
                "rgba(255, 99, 255, 0.8)",
                "rgba(54, 235, 235, 0.8)",
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
                "rgba(99, 255, 132, 1)",
                "rgba(255, 99, 255, 1)",
                "rgba(54, 235, 235, 1)",
              ],
              borderWidth: 1,
            },
          ],
        };

        setOfferData(processedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    getData();
  }, []);

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Total Offers by Product Name",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Product Names",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Offers",
        },
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
    plugins: {
      // Configure data labels
      datalabels: {
        anchor: "end",
        align: "end",
        formatter: (value) => Math.round(value), // Format as integer (no decimal places for offer counts)
        color: "#000", // Color of the text
        font: {
          weight: "bold",
        },
      },
    },
  };

  return (
    <div>
      <h2>Offers By Product</h2>
      <div style={{ height: "300px", width: "100%" }}>
        {offerData ? (
          <Bar
            data={offerData}
            options={{
              ...options,
              maintainAspectRatio: false, // Allow the chart to resize freely
              responsive: true, // Ensure the chart is responsive
            }}
          />
        ) : (
          <div className="relative min-h-[300px] flex items-center justify-center">
            <Spinner size="xl" fullScreen={true} />
          </div>
        )}
      </div>
    </div>
  );
}

export default PostByProduct;
